import { Component, inject } from '@angular/core';
import type { DatePicker } from 'primeng/datepicker';
import type { RcrStickyFooterConfig } from '../../rcr-exchange/shared/sticky-toolbar/rcr-exchange-footer.component';
import { MessageService } from '../services/message.service';

@Component({
  standalone: false,
  selector: 'invd-fm-calendar-picker',
  templateUrl: './calendar-picker.component.html',
  styleUrls: ['./calendar-picker.component.scss'],
})
export class CalendarPickerComponent {
  public config: RcrStickyFooterConfig;
  public invalidDates: Array<Date>;
  public minDateValue = new Date();
  public maxDateValue = new Date(
    this.minDateValue.getFullYear() + 1,
    this.minDateValue.getMonth(),
    this.minDateValue.getDate(),
  );

  private msgService = inject(MessageService);

  public static getFormatedDate(value: any): string {
    const mm = value.getMonth() + 1; // getMonth() is zero-based
    const dd = value.getDate();

    return [(mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd, value.getFullYear()].join('/');
  }

  public onSelect(value: any): void {
    if (this.config.change) {
      this.config.change(CalendarPickerComponent.getFormatedDate(value));
    }
    this.msgService.sendMessage(value);
  }

  public getExclusionDates(value: Array<Date>): void {
    this.invalidDates = value;
  }

  updateCalendarUI(calendar: DatePicker) {
    calendar.updateUI();
  }

  public onClick(value: any): void {
    if (this.config.click) {
      this.config.click(CalendarPickerComponent.getFormatedDate(value));
    }
  }
}
